// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-card-container{max-width:500px}@media screen and (min-width: 576px){.location-card-container{min-width:500px}}.location-card-container .card{border-left:4px solid #79757a}.location-card-container .card .sublocation-title-container{background-color:#5f5c60;color:#2d5286;padding-left:.25em}.location-card-container .card .location-image{height:auto;max-width:100%;min-height:150px;min-width:150px;object-fit:cover}", ""]);
// Exports
module.exports = exports;
